import React from "react";
import { preselectFilterStore } from "./preselectFilterStore";

/**
 * Re-renders the caller whenever preselectFilterStore mutates (deep link
 * consumed / target bound). The store is module state, not redux, so gates
 * derived from it (hasPendingDeepLink) get no re-render from a consumption
 * that happens outside a redux dispatch — e.g. the grid giving up on the deep
 * link's fetch. Returning the version also gives effects a dependency that
 * fires on consumption, so a build gated on the store re-runs instead of
 * leaving a stale Loader (or a silently blank body) on screen.
 *
 * Manual subscription (not useSyncExternalStore): the project is on React 16,
 * where legacy-mode rendering has no tearing to defend against.
 */
export const usePreselectStoreVersion = (): number => {
  const [version, setVersion] = React.useState<number>(preselectFilterStore.getVersion());

  React.useEffect(() => {
    const update = () => setVersion(preselectFilterStore.getVersion());
    const unsubscribe = preselectFilterStore.subscribe(update);
    // Catch a mutation that landed between the render that captured the
    // initial version and this subscription taking effect.
    update();
    return unsubscribe;
  }, []);

  return version;
};
